import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import { LoggedInUserID, LoggedInUserName } from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import { getUserLocation } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { formatIndianAmount, getAvgPricePerSqft } from "../Services/Helper";

const images = [
  "https://picsum.photos/id/1011/800/500",
  "https://picsum.photos/id/1012/800/500",
  "https://picsum.photos/id/1013/800/500",
  "https://picsum.photos/id/1015/800/500",
  "https://picsum.photos/id/1016/800/500",
];

const chipList = ["2BHK", "2.5BHK", "3BHK", "3.5BHK"];

function ProjectDetails() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const projectID = params.get("id");
  // const city = params.get("city");

  const [open, setOpen] = useState(false);

  const [projectDetails, setProjectDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [developerDetails, setDeveloperDetails] = useState(null);
  const [configDetails, setConfigDetails] = useState([]);
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    getProjectDetails(projectID);
  }, []);

  const getProjectDetails = (id) => {
    getRecords(398, 1, `{SocietyID: { $in: [${id}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setProjectDetails(data?.response?.records[0] || null);
          getDeveloperDetails(data?.response?.records[0]?.DeveloperID);
          getConfigDetails(data?.response?.records[0]?.SocietyID);
          getProperties(data?.response?.records[0]?.SubAreaID);
          setLoading(false);
        } else {
          setLoading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const getDeveloperDetails = (devID) => {
    getRecords(417, 1, `{DeveloperID: { $in: [${devID}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setDeveloperDetails(data?.response?.records[0] || null);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConfigDetails = (societyID) => {
    getRecords(
      416,
      10,
      `{SocietyID: { $in: [${societyID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setConfigDetails(data?.response?.records || []);
            setSelectedChip(data?.response?.records[0] || {});
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      }
    );
  };

  const getProperties = (SubAreaID) => {
    getRecords(
      384,
      50,
      `{SubAreaID: { $in: [${SubAreaID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setProperties(data?.response?.records || []);
          } else {
            console.log("Error in fetching featured properties", data);
          }
        }
      }
    );
  };

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const sliderImages =
    typeof projectDetails?.Images === "string" && projectDetails.Images.trim()
      ? projectDetails.Images.split(",").map((i) => i.trim())
      : images || [];

  const totalImages = sliderImages.length;

  const mainSettings = {
    asNavFor: nav2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    asNavFor: nav1,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: true,
    infinite: true,
    arrows: false,
  };
  const [selectedChip, setSelectedChip] = useState([]);

  return (
    <>
      <Header />
      {projectDetails !== null && (
        <div className="content-wrapper bg-seashell">
          <section className="property-details-wrap ptb-50">
            <div className="container">
              <div className="row gx-5">
                <div className="col-xl-8">
                  <div className="property-details">
                    <div className="card mb-30">
                      <Box position="relative">
                        <Box
                          sx={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            zIndex: 2,
                            background: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: 14,
                          }}
                        >
                          {totalImages ? activeIndex + 1 : 0} / {totalImages}
                        </Box>

                        <Slider {...sliderSettings}>
                          {typeof projectDetails?.Images === "string" &&
                          projectDetails.Images.trim() !== ""
                            ? projectDetails.Images.split(",").map(
                                (img, index) => (
                                  <div key={index}>
                                    <img
                                      src={img.trim()}
                                      alt={`slide-${index}`}
                                      style={{
                                        width: "100%",
                                        height: "280px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </div>
                                )
                              )
                            : images?.map((img, index) => (
                                <div key={index}>
                                  <img
                                    src={img}
                                    alt={`slide-${index}`}
                                    style={{
                                      width: "100%",
                                      height: "280px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              ))}
                        </Slider>

                        {/* View All Button */}
                        <div style={{ textAlign: "right", marginTop: -50 }}>
                          <Button
                            variant="outlined"
                            onClick={() => setOpen(true)}
                            className="vallimages"
                          >
                            View All Images
                          </Button>
                        </div>
                      </Box>
                    </div>
                    <div className="card pd-20 mb-30">
                      <div class="property-title">
                        <h2>{projectDetails.Society || ""}</h2>
                        <p>{projectDetails.Developer || ""}</p>
                        <ul class="property-metainfo list-style">
                          <li>
                            <i class="flaticon-location"></i>
                            {projectDetails?.Locality || ""}
                          </li>
                        </ul>
                        <div className="chipps">
                          <span className="property-condo">
                            {projectDetails?.ProjectStatus || ""}
                          </span>
                          {projectDetails?.RERAVerified === "Yes" && (
                            <span className="property-status">
                              Rera Verified
                            </span>
                          )}
                        </div>

                        <span>Unit Options</span>
                        <div className="chips-container">
                          {configDetails?.map((chip) => (
                            <button
                              key={chip.SocietyConfigID}
                              className={`chip ${
                                selectedChip.SocietyConfigID ===
                                chip.SocietyConfigID
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => setSelectedChip(chip)}
                            >
                              {chip.BHK}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="card pd-20 mb-30">
                      <h5>Pricing & Area</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style">
                          <li>
                            <span>Price Range</span> ₹
                            {formatIndianAmount(selectedChip?.Price) || ""}
                          </li>
                          <li>
                            <span>Carpet Area</span>{" "}
                            {selectedChip?.CarpetArea || ""}{" "}
                            {selectedChip?.UOMName || ""}
                          </li>
                          {/* <li>
                            <span>Avg. Price</span> ₹8,500/sq.ft
                          </li> */}
                        </ul>
                        <p>
                          Configuration:{" "}
                          {configDetails?.map((item) => item.BHK).join(", ")}
                        </p>
                        <small>*Price excludes stamp duty & registration</small>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>Quick Facts</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style facts">
                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="flaticon-square"></i>Project Area
                            </small>
                            {projectDetails?.ProjectArea} {projectDetails?.Area}
                          </li>
                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-scales-2-line"></i>Sizes
                            </small>
                            {projectDetails?.AreaRange || ""}
                          </li>

                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-building-3-line"></i>Project Size
                            </small>
                            {projectDetails?.ProjectSize || ""}
                          </li>
                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-calendar-2-line"></i>Launch Date
                            </small>
                            {projectDetails?.LaunchDate || ""}
                          </li>

                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-money-rupee-circle-line"></i>Avg
                              Price
                            </small>
                            ₹
                            {formatIndianAmount(
                              configDetails?.length
                                ? (() => {
                                    const prices = configDetails
                                      .map((item) => item?.Price)
                                      .filter((price) => price != null);

                                    return prices.length
                                      ? prices?.reduce((sum, p) => sum + p, 0) /
                                          prices.length
                                      : 0;
                                  })()
                                : 0
                            )}
                          </li>
                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-folder-keyhole-line"></i>
                              Possession
                            </small>
                            {projectDetails?.ProjectStatus || ""}
                          </li>
                          <li className="bg-seashell pd-20">
                            <small>
                              <i className="ri-shield-check-line"></i>RERA ID
                            </small>
                            <a href="#">{projectDetails?.RERAID || ""}</a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>Floor Plans</h5>
                      <div
                        class="property-desc bg-seashell pd-20"
                        style={{ borderRadius: 6 }}
                      >
                        <ul class="property-features list-style mb-0">
                          <li>
                            <div>
                              {selectedChip?.BHK || ""}
                              <small>
                                {selectedChip?.Bedrooms} Bed •{" "}
                                {selectedChip?.Bathrooms} Bath
                              </small>
                            </div>
                            <div>
                              ₹{formatIndianAmount(selectedChip?.Price || 0)}
                              <small>Starting Price</small>
                            </div>
                          </li>
                        </ul>
                        <div className="carpetblock">
                          <div className="carpet">
                            <img
                              src={
                                selectedChip?.FloorPlanImage ||
                                "../assets/img/carpet.jpg"
                              }
                              alt="Image"
                            />
                          </div>
                        </div>

                        <ul class="property-features list-style">
                          <li>
                            <div style={{ width: "50%", textAlign: "left" }}>
                              <small>Carpet Area</small>
                              {selectedChip?.CarpetArea || 0}{" "}
                              {selectedChip?.UOMName || ""}
                            </div>

                            <div style={{ width: "50%", textAlign: "left" }}>
                              <small>Built-up Area</small>
                              {selectedChip?.BuiltUpArea || 0}{" "}
                              {selectedChip?.UOMName || ""}
                            </div>
                          </li>
                        </ul>
                        <div className="header-btn">
                          <button
                            type="button"
                            className="btn style3 loginbtn"
                            style={{ marginRight: 10, background: "#fff" }}
                          >
                            Download Plan
                          </button>
                          <button type="button" className="btn style1">
                            Get Quote
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>Project Overview</h5>
                      <div class="property-desc">
                        <p>{projectDetails?.ProjectOverview || ""}</p>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>More About {projectDetails?.Society || ""}</h5>
                      <div class="property-desc">
                        <p>{projectDetails?.MoreAboutProject || ""}</p>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30 amenities">
                      <h5>Amenities</h5>
                      <div class="property-desc">
                        <div className="row d-flex df">
                          {projectDetails?.PropertyAmenities?.length > 0 &&
                            projectDetails.PropertyAmenities.map((amenity) => (
                              <div
                                key={amenity?.PropertyAmenitiesID}
                                className="property-card style3"
                              >
                                <div className="property-info">
                                  <div className="icons">
                                    <img
                                      src={
                                        amenity?.PropertyAmenitiesIcon ||
                                        "/assets/icons/default-amenity.png"
                                      }
                                      alt={
                                        amenity?.PropertyAmenities || "amenity"
                                      }
                                      className="amenity-icon"
                                    />
                                  </div>
                                  <p>{amenity?.PropertyAmenities}</p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30 amenities">
                      <h5>Location</h5>
                      <div class="property-desc">
                        <div className="map">
                          {projectDetails?.Coordinate && (
                            <iframe
                              src={`https://www.google.com/maps?q=${projectDetails?.Coordinate[0]},${projectDetails?.Coordinate[1]}&hl=en&z=15&output=embed`}
                              width="100%"
                              height="250"
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                            />
                          )}
                        </div>
                        {/* <p>Nearby Places</p>

                        <div class="property-desc">
                          <ul class="property-features list-style lst">
                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Whitefield Railway Station
                              </span>{" "}
                              <span>
                                2.5 km <small>8 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Phoenix MarketCity
                              </span>{" "}
                              <span>
                                3.5 km
                                <small>12 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>
                                Columbia Asia Hospital
                              </span>{" "}
                              <span>
                                1.5 km
                                <small>6 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Ryan International School
                              </span>{" "}
                              <span>
                                2.1 km <small>7 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Whitefield Railway Station
                              </span>{" "}
                              <span>
                                2.5 km<small>8 min</small>
                              </span>
                            </li>

                            <li>
                              <span className="d-flex">
                                <div className="grey">
                                  <i class="ri-train-line"></i>
                                </div>{" "}
                                Varthur Lake
                              </span>{" "}
                              <span>
                                1.2 km <small>4 min</small>
                              </span>
                            </li>
                          </ul>
                        </div> */}
                      </div>
                    </div>

                    <div className="card pd-20 mb-30 amenities">
                      <div class="property-desc mb-0">
                        <ul class="property-features list-style lst mb-0">
                          <li className="reraa">
                            <span className="d-flex">
                              <div className="grey ico">
                                <i class="ri-shield-check-line"></i>
                              </div>{" "}
                              <h5>
                                RERA Information
                                <small className="d-block">
                                  ID: {projectDetails?.RERAID || "N/A"}
                                </small>
                              </h5>
                            </span>{" "}
                            <span className="rera-details">
                              <span className="property-status">
                                Check Rera Status
                              </span>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="property-details">
                    <div className="card pd-20 mb-30">
                      <div class="property-title mb-0">
                        <h5>Contact Developer</h5>
                        <span>Developer</span>
                        <p>{projectDetails?.DeveloperName || "N/A"}</p>

                        <div className="header-btn d-block dev">
                          <button type="button" className="btn style1">
                            <i class="ri-phone-line"></i> Call Now
                          </button>

                          <button type="button" className="btn style3 loginbtn">
                            {" "}
                            Get Callback{" "}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>Price Summary</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style">
                          <li>
                            <span>Unit Type</span>{" "}
                            <span>{selectedChip?.BHK}</span>
                          </li>

                          <li>
                            <span>Price Range</span>{" "}
                            <span>
                              ₹{formatIndianAmount(selectedChip?.Price)}
                            </span>{" "}
                          </li>
                          <li>
                            <span>Carpet Area</span>{" "}
                            <span>
                              {selectedChip?.CarpetArea} {selectedChip?.UOMName}
                            </span>{" "}
                          </li>
                        </ul>
                        <ul
                          class="property-features list-style lst mb-0 pd-0"
                          style={{ paddingBottom: 0 }}
                        >
                          <li>
                            <span>Avg. Price/{selectedChip?.UOMName}</span>{" "}
                            <span className="prce">
                              ₹{getAvgPricePerSqft(selectedChip)}
                            </span>{" "}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}

      {/* Gallery Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <IconButton
          onClick={() => setOpen(false)}
          style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
        >
          x
        </IconButton>

        <DialogContent style={{ padding: 0, overflowY: "clip" }}>
          <Box position="relative">
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 2,
                background: "rgba(0,0,0,0.6)",
                color: "#fff",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: 14,
              }}
            >
              {activeIndex + 1} / {totalImages}
            </Box>

            {/* Main Slider */}
            <Slider {...mainSettings} ref={(s) => setNav1(s)}>
              {sliderImages?.map((img, index) => (
                <Box key={index}>
                  <img
                    src={img}
                    alt=""
                    style={{
                      width: "100%",
                      height: 400,
                      objectFit: "cover",
                      borderRadius: 0,
                    }}
                  />
                </Box>
              ))}
            </Slider>

            {/* Thumbnail Slider */}
            <Box mt={2}>
              <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                {sliderImages?.map((img, index) => (
                  <Box key={index} px={0.5}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: "100%",
                        height: 80,
                        objectFit: "cover",
                        borderRadius: 0,
                        cursor: "pointer",
                        border:
                          activeIndex === index
                            ? "2px solid #1976d2"
                            : "2px solid transparent",
                      }}
                    />
                  </Box>
                ))}
              </Slider>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Footer />

      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </>
  );
}

export default ProjectDetails;
